import Vue from 'vue'
import Router from 'vue-router'
import _interceptor from './_interceptor'
const { isNavigationFailure, NavigationFailureType } = Router

const originalPush = Router.prototype.push
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalPush.call(this, location, onResolve, onReject)
  }
  return originalPush.call(this, location).catch((err) => {
    if (isNavigationFailure(err, NavigationFailureType.cancelled)) {
      console.log(err, 'NavigationFailureType.cancelled')
      return
    }
    if (isNavigationFailure(err, NavigationFailureType.redirected)) {
      // src/router/_interceptor/statusRedirect
      console.log(err, 'NavigationFailureType.redirected')
      return
    }
    // if (err === undefined || err === false) {
    //   // next('/other') next(false) 고려..
    //   // console.log(err, 'location')
    //   Vue.config.errorHandler(err)
    // } else {
    //   // console.error(err, 'location')
    //   Vue.config.errorHandler(err)
    // }
    Vue.config.errorHandler(err)
  })
}

const routers = [
  require('./auth'),
  require('./error'),
  require('./main'),
  require('./signup'),
  require('./signin'),
  require('./signout'),
  require('./guide'),
  require('./my'),
  require('./payments'),
  require('./purchase'),
  require('./credit'),
  require('./terms'),
  require('./wholesaler'),
  require('./settlement'),
]

Vue.use(Router)

let mergeRouters = []
routers.forEach((route) => {
  mergeRouters = mergeRouters.concat(route.default)
})

const vueRouter = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: mergeRouters,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
})

_interceptor.forEach((f) => {
  vueRouter.beforeEach(f.default)
})

vueRouter.afterEach((to, from) => {
  window?.dataLayer?.push({ contentViewName: to?.name, prevContentViewName: from?.name })
})

export default vueRouter
